<template>
    <div :class="xs ? 'cardxs' : 'card'">
        <div :class="xs ? 'circlexs' : 'circle'"></div>
        <div :class="xs ? type === STRING_GENERAL.SERVER ? 'contentxs' : 'contentxsLTE' :'content'">
            <v-row class=ma-0 >
                <v-sheet width="max-content" color=transparent  class="mr-2">
                    <div class="my-2">IP:</div>
                    <div class="my-2">{{ t('labels.uptime') }}:</div>
                </v-sheet> 
                <v-sheet width="max-content" color=transparent class="ml-2">
                    <div class="my-2"> {{ ip }} </div>
                    <div class="my-2">{{sysuptime}}</div>
                </v-sheet> 
            </v-row>
            <p >{{ t('labels.status') }}: </p>
            <v-row class="ma-0" :class="xs ? 'statusRowXS' : 'statusRow'" justify="center">
                <v-col class="pa-1" cols="3" sm='2' md="2" lg="2" xl="2" v-for="(elem,i) in statusElem" :key="i">
                        <v-sheet 
                        color="transparent" 
                        class="card-status text-center pa-0 py-1"
                        >
                            <v-icon :color="elem.status===1?'green':'black'">
                                {{ elem.icon }}
                            </v-icon>
                            <p class='titleStatus'> {{ elem.title }} </p> 
                        </v-sheet>
                </v-col>
            </v-row>
        </div>
        <v-img
        :class="type === STRING_GENERAL.SERVER ? 'card-img' : 'card-imgLTE'" 
        :src="finalImage"
        >
        </v-img> 
        <v-btn 
        v-if="type === STRING_GENERAL.SERVER" 
        :class="xs ? 'imgclickXS' : 'imgclick'"
        @click="type === STRING_GENERAL.SERVER ? showMVSDialog() : null" 
        >
        Clickme
        </v-btn>

        <h4 :class="type === STRING_GENERAL.SERVER ? 'title' : 'titleLTE'">{{name}}</h4> 
    </div>
    
    <v-dialog width="90%" v-model="showServerMVS">
        <v-card class="card_dialog" color="background"> 
            <v-row class="ma-0" justify="space-between" style="align-items: self-end !important;" >
                <v-col cols="10">
                    <v-row class="ma-0">
                        <h3 style="width:max-content" class=mr-4> {{ t('labels.virtMach') }} - {{ ip }} </h3>
                        <v-tooltip text="OK" location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-sheet v-bind="props" class="sheetIcons pa-1" color="green" width="50">
                                    <v-icon> mdi-thumb-up-outline</v-icon>
                                </v-sheet>
                            </template>
                        </v-tooltip>
                        <v-tooltip text="Alertas" location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-sheet v-bind="props" class="sheetIcons pa-1"  color="yellow" width="50">
                                    <v-icon> mdi-alarm-light-outline</v-icon>
                                </v-sheet>
                            </template>
                        </v-tooltip>
                        <v-tooltip text="Alarmas" location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-sheet v-bind="props" class="sheetIcons pa-1"  color="red" width="50">
                                    <v-icon> mdi-alert-box-outline</v-icon>
                                </v-sheet>
                            </template>
                        </v-tooltip>
                    </v-row>
                </v-col>
                <v-col cols="1">
                    <v-btn icon="mdi-close" variant="plain" @click="showServerMVS = false"></v-btn>
                </v-col>
            </v-row>
            <v-divider class="mt-4"></v-divider>
            <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                    <v-sheet class="defaultCard text-center" color="bgtopology">
                        <VirMacComponent
                        :ip="[ip]"
                        :rows="25"
                        :recharge="false"
                        :emited="true"
                        />
                    </v-sheet>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>

</template>

<script setup lang="ts">
import { ref} from 'vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { STRING_GENERAL } from '@/constants/labels';
import CONSTANTIMGS from '@/constants/images';

/********************************
 ********** COMPONENTS **********
 *******************************/
import VirMacComponent from './VirMacDialog.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { LTE_STATUS } from '@/interfaces/SmartLink/LTE';
import { IMGS } from '@/interfaces/SmartLink/Imgs';


const props = defineProps({
    name        : { required:true, type:String },
    sysuptime   : { required:true, type:String },
    ip          : { required:true, type:String },
    type        : { required:true, type:String },
    arrayTable  : { type:Array, required:true, },
    statusElem  : { type:Array as () => LTE_STATUS[], required:true },
})

const showServerMVS     = ref(false);

const finalImage        = ref();
const CONST_IMG:IMGS    = {
    "LTE"           : CONSTANTIMGS.IMAGES.lte,
    "SERVER"        : CONSTANTIMGS.IMAGES.server,
};
finalImage.value        = CONST_IMG[props.type];

const showMVSDialog = async () => {
    showServerMVS.value = true;            
}

</script>

<style>

.sheetIcons{
    margin: 0 6px;
    border-radius: 10px;
    text-align: center;
}

.btnIP:hover{
    cursor: pointer;
    font-weight: bold;
}

.header_container{
    flex-direction: column !important;
}

.imgclick{
    z-index : 10;
    position: absolute;
    left    : 50%;
    top     : 30%;
    width   : 210px;
    height  : 75px !important;
    opacity : 0;
}

.imgclick:hover{
    cursor  : pointer;
}

.menu_card{
    border-radius: 20px !important;
    background-color: rgba(14, 47, 90, 0.8) !important;
}

.server_icon{
    /* border: 2px solid rgba(0, 0, 0, 0.3);
    border-radius: 50%; */
    transition: 0.7s;
}

.server_icon:hover{
    cursor: pointer;
    color: #86c4f3 !important;
    transition: 0.7s;
    transform: translateY(10px);
}


.titleStatus{
    font-size: 14px;
}

.card-status{
    padding: 4px;
    border-radius: 15px;
    border: 1px solid rgba(0,0,0,0.3);
} 

.card-status-hover{
    cursor: pointer;
    transform: scale(1);
    transition: 0.5s;
}

.card-status-hover:hover{
    /* cursor: pointer; */
    transform: scale(1.1);
    transition: 0.5s;
}
.card{    
    position: relative;
    width: 500px;
    height: 370px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    transition: 0.7s;   
    margin: 0 auto; 
    overflow: hidden;
}

.card .circle{
    position: absolute;    
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;    
    border-radius: 20px;
    overflow: hidden;
}

.statusRow{
    position: absolute;
    width: 154%;
}

.card .circle::before{
    content: "";
    position: absolute;    
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:radial-gradient(rgb(var(--v-theme-bgCard)) , #007FE3);
    /* background-color: rgb(var(--v-theme-bgCard)); */
    box-shadow: #fff;
    clip-path: circle(120px at center);
    transition: 0.7s;
}

.card:hover{
    box-shadow: 5px 5px 6px rgb(var(--v-theme-LTECardShadow));
}

.card:hover .circle:before{
    background:radial-gradient(#BBE0FC , #007FE3) !important;
    /* background-color:#007FE3; */
    clip-path: circle(320px at center);
    border-radius: 20px;
    border: 4px solid rgba(0,0,0,.2);
    transition: 0.7s;
}

.card .card-img,
.cardxs .card-img{
    position: absolute;
    top: 65%;
    left: 51%;
    width: 200px;
    transform: translate(-50%,-80%);
    pointer-events: none;
    transition: 0.7s;
    filter: drop-shadow(0px 23px 12px rgba(63,63,63,0.7));
}

.card:hover .card-img{
    color: #fff;
    top: 40%;
    left: 75%;
    width: 240px;
    transform: translate(-50%,-50%);
    transition: 0.7s;    
}

.card .card-imgLTE,
.cardxs .card-imgLTE{
    position: absolute;
    top: 55%;
    left: 50%;
    width: 120px;
    transform: translate(-50%,-80%);
    pointer-events: none;
    transition: 0.7s;
    filter: drop-shadow(0px 23px 12px rgba(63,63,63,0.7));
}

.card:hover .card-imgLTE{
    color: #fff;
    top: 30%;
    left: 75%;
    width: 140px;
    transform: translate(-50%,-50%);
    transition: 0.7s;    
}

.card .title{
    width: 200px;
    color: rgb(var(--v-theme-LTECardTitle));
    position: absolute;
    align-items: baseline;
    /* text-align: center; */
    top: 63%;
    left: 30%;    
    pointer-events: none;
    transition: 0.7s;
}

.card .titleLTE{
    width: 200px;
    color: rgb(var(--v-theme-LTECardTitle));
    position: absolute;
    align-items: baseline;
    text-align: center;
    top: 65%;
    left: 30%;    
    /* transform: translate(-50%,0%); */
    pointer-events: none;
    transition: 0.7s;
}

.card:hover .title{
    width: 300px;
    text-align: left;
    color: #fff;
    text-shadow: 3px 3px 3px black;
    left: 5%;
    top: 15%;    
    transition: 0.7s;
}

.card:hover .titleLTE{
    width: 300px;
    text-align: left;
    color: #fff;
    text-shadow: 3px 3px 3px black;
    left: 45%;
    top: 25%;    
    transform: translate(-60%,-120%);
    transition: 0.7s;
}
.card .content{
    position: absolute;
    width: 60%;
    left: 20%;
    top:29%;
    transition: 0.7s;
    opacity: 0;
    visibility: hidden;
}

.card:hover .content{
    color:#fff;
    left: 5%;
    text-align: start;
    visibility: visible;
    opacity: 1;
    transition: 0.7s;
}

.card .content .title{
    transition: 0.7s;
    visibility: visible;
}
.card .content .titleLTE{
    transition: 0.7s;
    visibility: visible;
}


/** 
    CARD XS (Moviles)
*/

.cardxs{
    position: relative;
    width: 350px;
    height: 470px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    transition: 0.7s;   
    margin: 0 auto;
    overflow: hidden; 
}

.cardxs .circlexs{
    position: absolute;    
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;    
    border-radius: 20px;
    overflow: hidden;
}

.cardxs .circlexs::before{
    content: "";
    position: absolute;    
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:radial-gradient(rgb(var(--v-theme-bgCard)) , #007FE3);
    /* background-color: rgb(var(--v-theme-bgCard)); */
    box-shadow: #fff;
    clip-path: circle(120px at center);
    transition: 0.7s;
}

.cardxs:hover .circlexs:before{
    background:radial-gradient(#BBE0FC , #007FE3) !important;
    clip-path: circle(300px at center);
    border-radius: 20px;
    border: 4px solid rgba(0,0,0,.2);
    transition: 0.7s;
}

.cardxs:hover .card-imgLTE{
    color: #fff;
    top: 30%;
    left: 65%;
    width: 220px;
    transform: translate(-50%,-50%);
    transition: 0.7s;    
}

.cardxs:hover .card-img{
    color: #fff;
    top: 20%;
    left: 68%;
    width: 240px;
    transform: translate(-50%,-50%);
    transition: 0.7s;    
}

.imgclickXS{
    background-color: red !important;
    z-index : 10;
    position: absolute;
    left    : 35%;
    top     : 10%;
    width   : 210px;
    height  : 75px !important;
    opacity : 0;
}

.imgclickXS:hover{
    cursor  : pointer;
}

.cardxs .title{
    width: 200px;
    color: rgb(var(--v-theme-LTECardTitle));
    position: absolute;
    align-items: baseline;
    text-align: center;
    top: 55%;
    left: 50%;    
    transform: translate(-50%,50%);
    pointer-events: none;
    transition: 0.7s;
}

.cardxs:hover .title{
    width: 300px;
    text-align: left;
    color: #fff;
    text-shadow: 3px 3px 3px black;
    left: 58%;
    top: 16%;    
    transform: translate(-60%,-120%);
    transition: 0.7s;
}

.cardxs .titleLTE{
    width: 180px;
    color: rgb(var(--v-theme-LTECardTitle));
    position: absolute;
    align-items: baseline;
    text-align: center;
    top: 65%;
    left: 25%;    
    /* transform: translate(-50%,0%); */
    pointer-events: none;
    transition: 0.7s;
}
.cardxs:hover .titleLTE{
    width: 250px;
    text-align: left;
    color: #fff;
    text-shadow: 3px 3px 3px black;
    left: 40%;
    top: 15%;    
    transform: translate(-50%,-120%);
    transition: 0.7s;
}
.cardxs .contentxs{
    position: absolute;
    width: 80%;
    top:30%;
    left: 20%;
    transition: 0.7s;
    opacity: 0;
    visibility: hidden;
}
.cardxs:hover .contentxs{
    color:#fff;
    left: 5%;
    text-align: start;
    visibility: visible;
    opacity: 1;
    transition: 0.7s;
}

.statusRowXS{
    position: absolute;
    left:-2%;
    width: 110%;
}

.cardxs .contentxsLTE{
    position: absolute;
    width: 50%;
    top:45%;
    left: 20%;
    padding: 100px,20px,20px,40px;
    transition: 0.7s;
    opacity: 0;
    visibility: hidden;
}
.cardxs:hover .contentxsLTE{
    color:#fff;
    left: 5%;
    text-align: start;
    visibility: visible;
    opacity: 1;
    transition: 0.7s;
}

.card-lte1{
    border-radius: 20px;
    border: 3px solid rgba(0, 0, 0, .2);
    background-color: #0cbaba;
    background-image: linear-gradient(315deg, #0cbaba 0%, #060038 70%);
}
.card-lte2{
    border-radius: 20px;
    border: 3px solid rgba(0, 0, 0, .2);
    background-color: #0cbaba;
    background-image: linear-gradient(45deg, #0cbaba 0%, #060038 70%);
}
.card-lte3{
    border-radius: 20px;
    border: 3px solid rgba(0, 0, 0, .2);
    background-color: #0cbaba;
    background-image: linear-gradient(225deg, #0cbaba 0%, #060038 70%);
}
.card-lte4{
    border-radius: 20px;
    border: 3px solid rgba(0, 0, 0, .2);
    background-color: #0cbaba;
    background-image: linear-gradient(135deg, #0cbaba 0%, #060038 70%);
}

.card-lte1 .vue-map{
    border-radius: 20px !important;
}



</style>